module.exports = __webpack_public_path__ + "media/images/realizacje/real10-4553ec4f409d7e019d13c0f085b34a3c.png";